<script>
    import { onMount } from 'svelte';
    import ReportsService from "../../services/reports.service";
    import EditableCell from "../../components/EditableCell.svelte";
    import AuthService from '../../services/auth.service.js';
    import HRService from '../../services/hr.service.js';
    import Loader from "../../components/Loader.svelte";
    import {formatValue} from '../../helpers/format.helper';

    let page, loading = false, reportData, errorMessage;
    let totals = {
        openRoles: {
            sales: 0,
            marketing: 0,
            total: 0,
        },
        holdRoles: {
            sales: 0,
            marketing: 0,
            total: 0,
        },
        avgTimeToFill: {
            sales: 0,
            marketing: 0,
            total: 0,
        },
        headCounts: {
            sales: 0,
            marketing: 0,
            total: 0,
        }
    }

    export let user, params;

    //Catch when a value change
    $: loadData(params);

    onMount(() => {
        loadData();
    });

    async function loadData() {
        if (loading) return;
        loading = true;
        reportData = null;
        const url = '/org/' + params.org + '/hr_staffing_aggregate/date/' + params.year
        let result = null;

        try {
            result = await ReportsService.load(url);
        } catch (e) {
            console.log('Error', e);
        }

        if (result && result.data) reportData = result.data;
        getTotals();
        loading = false;
        setTimeout(() => {
            tablesLoaded(true);
            enableTableSelection();
        }, 1000);
    }

    async function updateMonthlyTracker(value, id, date, field){
        if(jQuery('.hr-pasting').length > 0){
            // Avoid save all the string pasted on the selected cell
            return false;
        }
        try {
            let body;
            if(field == 'actual'){
                body = {"monthly_talent_kpi_id": id, date, "actual": value};
            }else{
                body = {"monthly_talent_kpi_id": id, date, "target": value};
            }
            await ReportsService.updateMonthlyTracker(body);
        } catch (e) {
            console.log('Error', e);
        }
    }

    function getTotals(){
        totals = {
            openRoles: {
                sales: 0,
                marketing: 0,
                total: 0,
            },
            holdRoles: {
                sales: 0,
                marketing: 0,
                total: 0,
            },
            avgTimeToFill: {
                sales: 0,
                marketing: 0,
                total: 0,
            },
            headCounts: {
                sales: 0,
                marketing: 0,
                total: 0,
            }
        }

        reportData.dataTracking.forEach((company, companyIndex) => {
            Object.keys(company).sort().forEach((key, keyIndex) => {
                if(key != 'name'){
                    Object.keys(company[key]).sort().forEach((department, value) => {
                        totals[key][department] += company[key][department];
                    });
                }
            });
        });
    }

</script>

{#if loading}
    <Loader></Loader>
{:else}
    <button class="d-none" id="reloadData" on:click={loadData}>RELOAD</button>
    <div class="table-wrapper hr-report">
        <table class="table table-striped table-sm container-fluid selectable-table">
            <thead>
                <tr class="bg-dark text-light">
                   <th rowspan="2">Company</th>
                   <th colspan="3"># Open Roles</th>
                   <th colspan="3"># Roles on Hold</th>
                   <th colspan="3">Avg Time to Fill (D)</th>
                   <th colspan="3">Current Headcount</th>
                </tr>
                <tr class="bg-dark text-light">
                    <th>Sales</th>
                    <th>Marketing</th>
                    <th>Total</th>
                    <th>Sales</th>
                    <th>Marketing</th>
                    <th>Total</th>
                    <th>Sales</th>
                    <th>Marketing</th>
                    <th>Total</th>
                    <th>Sales</th>
                    <th>Marketing</th>
                    <th>Total</th>
                </tr>
            </thead>
            <tbody>
                {#each reportData.dataTracking as company, companyIndex}
                    <tr>
                        <td class="readOnly text-left aggregate_br-black {(companyIndex%2 == 0)? 'style-grey' : ''}">{company.name || 0}</td>
                        <!-- Open roles columns -->
                        <td class="readOnly aggregate_br-grey {(companyIndex%2 == 0)? 'style-grey' : ''}">{company.openRoles.sales || 0}</td>
                        <td class="readOnly aggregate_br-grey {(companyIndex%2 == 0)? 'style-grey' : ''}">{company.openRoles.marketing || 0}</td>
                        <td class="readOnly aggregate_br-black {(companyIndex%2 == 0)? 'style-grey' : ''}">{company.openRoles.total || 0}</td>
                        <!-- Hold roles columns -->
                        <td class="readOnly aggregate_br-grey {(companyIndex%2 == 0)? 'style-grey' : ''}">{company.holdRoles.sales || 0}</td>
                        <td class="readOnly aggregate_br-grey {(companyIndex%2 == 0)? 'style-grey' : ''}">{company.holdRoles.marketing || 0}</td>
                        <td class="readOnly aggregate_br-black {(companyIndex%2 == 0)? 'style-grey' : ''}">{company.holdRoles.total || 0}</td>
                        <!-- Hold roles columns -->
                        <td class="readOnly aggregate_br-grey {(companyIndex%2 == 0)? 'style-grey' : ''}">{company.avgTimeToFill.sales || 0}</td>
                        <td class="readOnly aggregate_br-grey {(companyIndex%2 == 0)? 'style-grey' : ''}">{company.avgTimeToFill.marketing || 0}</td>
                        <td class="readOnly aggregate_br-black {(companyIndex%2 == 0)? 'style-grey' : ''}">{company.avgTimeToFill.total || 0}</td>
                        <!-- Hold roles columns -->
                        <td class="readOnly aggregate_br-grey {(companyIndex%2 == 0)? 'style-grey' : ''}">{company.headCounts.sales || 0}</td>
                        <td class="readOnly aggregate_br-grey {(companyIndex%2 == 0)? 'style-grey' : ''}">{company.headCounts.marketing || 0}</td>
                        <td class="readOnly aggregate_br-black {(companyIndex%2 == 0)? 'style-grey' : ''}">{company.headCounts.total || 0}</td>
                    </tr>
                {/each}
                <tr>
                    <td class="readOnly text-left aggregate_br-black total-row">Total</td>
                    <!-- Open roles columns -->
                    <td class="readOnly aggregate_br-grey total-row">{totals.openRoles.sales}</td>
                    <td class="readOnly aggregate_br-grey total-row">{totals.openRoles.marketing}</td>
                    <td class="readOnly aggregate_br-black total-row">{totals.openRoles.total}</td>
                    <!-- Hold roles columns -->
                    <td class="readOnly aggregate_br-grey total-row">{totals.holdRoles.sales}</td>
                    <td class="readOnly aggregate_br-grey total-row">{totals.holdRoles.marketing}</td>
                    <td class="readOnly aggregate_br-black total-row">{totals.holdRoles.total}</td>
                    <!-- Hold roles columns -->
                    <td class="readOnly aggregate_br-grey total-row">{totals.avgTimeToFill.sales}</td>
                    <td class="readOnly aggregate_br-grey total-row">{totals.avgTimeToFill.marketing}</td>
                    <td class="readOnly aggregate_br-black total-row">{totals.avgTimeToFill.total}</td>
                    <!-- Hold roles columns -->
                    <td class="readOnly aggregate_br-grey total-row">{totals.headCounts.sales}</td>
                    <td class="readOnly aggregate_br-grey total-row">{totals.headCounts.marketing}</td>
                    <td class="readOnly aggregate_br-black total-row">{totals.headCounts.total}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="row">
        <div class="col-md-6">
            <div class="row">
                <div class="col-md-6">
                    <b>GRAND TOTAL: OPEN ROLES</b>
                </div>
                <div class="col-md-6">
                    {totals.openRoles.total + totals.holdRoles.total}
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b>Open Sales Roles</b>
                </div>
                <div class="col-md-6">
                    {totals.openRoles.sales + totals.holdRoles.sales}
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="row">
                <div class="col-md-6">
                    <b>Open Marketing Roles</b>
                </div>
                <div class="col-md-6">
                    {totals.openRoles.marketing + totals.holdRoles.marketing}
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <b>Avg Time to Fill (Days all-time)</b>
                </div>
                <div class="col-md-6">
                    {totals.avgTimeToFill.total}
                </div>
            </div>
        </div>
    </div>

    <!-- Monthly SE Talent Tracker -->
    <div class="table-wrapper">
        <h5 class="font-weight-5">Monthly SE Talent Tracker</h5>
        <table class="table table-sm container-fluid selectable-table">
            <thead>
                <tr class="bg-dark text-light">
                    <th class="aggregate_kpi">KPIs</th>
                    <th class="aggregate_taxonomy">Metrics Taxonomy and Definitions</th>
                    <th class="aggregate_type">Actual/Target</th>
                    {#each Object.keys(reportData.monthlyTalentKpis[0].kpiData) as key}
                        <th>{key}</th>
                    {/each}
                </tr>
            </thead>
            <tbody>
                {#each reportData.monthlyTalentKpis as kpi, row}
                    <tr>
                        <td class="header-color">{kpi.title}</td>
                        <td class="taxonomy-color">{kpi.taxonomy}</td>
                        <td class="type-color"><small>Actual<hr>Target</small></td>
                        {#each Object.keys(reportData.monthlyTalentKpis[0].kpiData) as key, column}
                            <td>
                                {#if kpi.title == 'Number of Open Roles'}
                                    <EditableCell
                                        bind:value={kpi.kpiData[key].actual}
                                        id="t0-1-{column}"
                                        on:change={(e) => updateMonthlyTracker(e.detail.value, kpi.id, key, 'actual')}
                                        format=0>
                                    </EditableCell>
                                {:else}
                                    <span class="readOnly">{kpi.kpiData[key].actual}</span>
                                {/if}
                                <hr>
                                <EditableCell
                                    bind:value={kpi.kpiData[key].target}
                                    id="t0-{(row > 0)? row+1 : row}-{column}"
                                    on:change={(e) => updateMonthlyTracker(e.detail.value, kpi.id, key, 'target')}>
                                    format=0></EditableCell>
                            </td>
                        {/each}
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
{/if}
